<template>
  <div id="app">
    <nav class="bottom">
        <div class="container">
          <div class="nav">
            <a class="nav-item homelink" v-scroll-to="'.home'"><icon name="home" scale="2"></icon></a>
            <a v-scroll-to="'.about'" class="nav-item aboutlink"><icon name="address-card" scale="2" class="is-hidden-desktop fa-2x"></icon><span class="is-hidden-touch">About</span></a>
            <a v-scroll-to="'.clients'" class="nav-item clientslink"><icon name="handshake-o" scale="2" class="fa fa-handshake-o is-hidden-desktop fa-2x"></icon><span class="is-hidden-touch">Clients</span></a>
            <a v-scroll-to="'.results'" class="nav-item resultslink"><icon name="bar-chart" scale="2" class="fa fa-bar-chart is-hidden-desktop fa-2x"></icon><span class="is-hidden-touch">Results</span></a>
            <a v-scroll-to="'.gallery'" class="nav-item gallerylink"><icon name="image" scale="2" class="fa fa-image is-hidden-desktop fa-2x"></icon><span class="is-hidden-touch">Gallery</span></a>
            <a v-scroll-to="'.contact'" class="nav-item contactlink"><icon name="envelope-open" scale="2" class="fa fa-envelope-open is-hidden-desktop fa-2x"></icon><span class="is-hidden-touch">Contact</span></a>
            <a class="nav-item is-hidden-touch" v-scroll-to="'.home'"><img src="./assets/visible_logo.png" class="is-pulled-right" /></a>
          </div>
        </div>
      </nav>
    <div class="bmv-reflective">
      <section class="hero bg-orange is-fullheight home">
        <bubbles></bubbles>
        <div class="home-body has-text-centered">
          <img src="static/visible_logo.png" class="main-logo" alt="Visible">
          <h1 class="headline subtitle">We make businesses more visible on the web.</h1>
        </div>
      </section>
      <section class="hero bg-darkblue is-fullheight about">
        <div class="flag">
          <h1>About Visible</h1>
        </div>
        <div class="hero-body">
          <div class="container">
            <about></about>
          </div>
        </div>
      </section>
      <section class="hero bg-clients clients">
        <div class="flag">
          <h1>Visible Clients</h1>
        </div>
        <div class="hero-body">
          <div class="container">
            <h1 class="intro">Just a Few of Our Clients &amp; Partners</h1>
            <clientlist></clientlist>
          </div>
        </div>
      </section>
      <div class="results">
        <section class="hero bg-lightblue is-fullheight">
          <div class="flag">
            <h1>Visible Results</h1>
          </div>
          <div class="hero-body">
            <div class="container">
              <h1 class="intro">Our Results Speak For Themselves</h1>
              <bmv-bar-chart client="Analytics8" finder="chart--A8" :chartdata="[89.62108731, 82.04283361, 93.73970346, 100, 139.3739703, 128.0889621, 138.9621087, 141.6803954, 155.601318,  142.9983526, 183.1960461, 197.9406919, 197.1169687, 161.4497529, 192.9159802, 213.0971993, 237.4794069]"
                :initialmonth="3" monthlabel="Month" left="1">
                <p>Redeveloped Analytics8.com to be more accessible to search engine crawlers</p>
                <p>Immediate improvement of 39% in the first month</p>
                <p>More than doubled traffic within one year</p>
              </bmv-bar-chart>
              <bmv-bar-chart client="Vi" finder="chart--Vi" :chartdata="[100, 140.2236679, 133.4917038, 170.0899057, 168.7888312, 187.8517652, 224.4645859, 213.2811929, 209.9481032, 245.9980996, 210.715591,  214.845406,  231.9859659, 262.8170455, 225.166289,  221.8697464, 207.3020978, 255.7853958, 218.5512755, 265.9235436]"
                :initialmonth="0" monthlabel="Quarter" left="0">
                <p>Optimized ViLiving.com</p>
                <p>Immediate improvement of 40% in the first month</p>
                <p>More than doubled traffic within 6 quarters</p>
              </bmv-bar-chart>
              <bmv-bar-chart client="Corporate Suites Network" finder="chart--CSN" :chartdata="[100, 169.0023753, 167.3396675, 220.4275534, 226.128266, 242.8741093, 242.1615202, 234.0855107, 215.9144893, 209.7387173, 216.7458432, 187.1733967, 151.9002375, 225.5344418, 224.584323, 282.304038, 321.2589074, 345.1306413, 334.6793349]" :initialmonth="-1" monthlabel="Month" left="0">
                <p>Developed and optimized HabitatCSN.com</p>
                <p>Managed SEO aspects of branding transition to CSNHousing.com</p>
                <p>Dramatically increased traffic year over year</p>
              </bmv-bar-chart>
            </div>
          </div>
        </section>
      </div>
      <div class="gallery">
        <section class="hero bg-orange is-fullheight">
          <div class="flag">
            <h1 class="right">Visible Gallery</h1>
          </div>
          <div class="hero-body">
            <div class="container">
              <h1 class="intro">We Make Cool Sites, See?</h1>
              <gallery></gallery>
            </div>
          </div>
        </section>
      </div>
      <div class="contact">
        <section class="hero bg-map is-fullheight">
          <div class="flag">
            <h1>Contact Visible</h1>
          </div>
          <div class="hero-body">
            <div class="container">
              <h1 class="intro">Based In Chicago, Serving Clients Nationwide</h1>
              <contact></contact>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!--googleoff: all-->
    <div class="bmv-reflection-container bottom">
    </div>
    <!--googleon: all-->
  </div>
</template>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Playfair+Display|Raleway');
  // $fa-font-path: '../node_modules/font-awesome/fonts/';
  // @import 'node_modules/font-awesome/scss/font-awesome';
  // $footerSize: 500px;
  $footerSize: 11vh;
  $blur: 4px;
  $opacity: 0.65;
  .bubbles {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
  }
  .main-logo {
    padding:20px;
  }
  .headline.subtitle {
    padding:0px 20px;
  }
  @media screen and (max-width:750px) {
    .fa-2x {
      font-size: 5vh;
    }
  }
  * {
    font-family:'Raleway',serif;
  }
  h1,h2,h3,h4,h5,h6 {
    font-family:'Playfair Display',serif;
  }
  .home .home-body {
    pointer-events: none;
  }
  .home-body {
    padding-top:30vh;
    z-index:20;
  }
  h1.headline {
    font-size: 20pt;
    line-height: 40pt;
    color: white;
    text-shadow: -1px -1px 0px rgba(255,255,255,0.1), 1px -1px 0px rgba(255,255,255,0.1), -1px 1px 0px  rgba(0,0,0,0.4), 1px 1px 0px rgba(0,0,0,0.4);
   font-family:'Playfair Display',serif;
    // text-shadow:0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #00deff, 0 0 70px #00deff, 0 0 80px #00deff, 0 0 100px #00deff, 0 0 150px #00deff;
    // font-weight:bold;
  }
  
  h1.intro {
    font-size:42px;
    font-family:'Playfair Display',serif;
    @media (max-width:750px) {
      font-size:30px;
      line-height:42px;
    }  
    line-height:60px;
    color:#000;
    text-shadow: 3px 3px rgba(black, 0.2);
    color:#fff;
    // text-decoration:underline;
    text-align:center;
    font-weight: bold;
    margin:20px 0px;
  }
  nav {
    position: fixed !important;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 10001;
    background-color: rgba(255, 255, 255, 0.1);
  }
  nav.bottom {
    bottom: 0;
    top: auto;
    height:$footerSize;
  }
  nav .nav {
    top: 0;
    left: 0;
    right: 0;
    background: none;
    height: $footerSize;
    display: table;
    width: 100%;
  }
  nav .nav .nav-item {
    color: #aaa;
    display: table-cell;
    background: none;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    // text-shadow: 2px 2px rgba(black, 0.2);
    // margin:20px 0px;
    padding: 0;
    margin: 0;
    font-weight: bold;
    text-transform: uppercase;
    text-shadow:1px 1px 2px rgba(0,0,0,0.5);
    background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.25) 100%);
    background-position-y: 11vh;
    background-repeat: no-repeat;
    transition: background 200ms ease-out;
    &:hover {
      background-position-y: 0vh;
    }
    &:last-child {
      border-right: none;
      &:hover {
        background-position-y:11vh;
      }
    }
    &.active {
      color: #fff;
    }
    &:hover {
      color: #fff;
    }
    text-align:center;
    vertical-align:middle;
  }
  h1 {
    font-size: 20pt;
    color: #fff;
    display: block;
    font-family:'Playfair Display',serif;
  }
  .bmv-reflection section>.flag {
    position:relative;
  }
  section>.flag {
    position: sticky;
    top: 0px;
    overflow: hidden;
    height: 150px;
    @media (max-width:800px) {
      height:90px;
      top:-1px;
    }
    z-index: 6;
    pointer-events:none;
    h1 {
      font-family:'Raleway',sans-serif;
      text-align: center;
      font-size: 14px;
      // letter-spacing:0.05em;
      text-transform: uppercase;
      color: #fff;
      // text-shadow:2px 2px rgba(black, 0.2);
      border: 1px solid #fff;
      max-width: 400px;
      padding: 10px;
      z-index: 400;
      background-color: darken(#0099cc, 20%);
      box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.6);
      width:400px;
      transform: translateX(calc(100vw - 400px)) rotate(30deg) translate(115px, -25px);
      @media (max-width:800px) {
        font-size:10px;
        transform: translateX(calc(100vw - 400px)) rotate(30deg) translate(140px, -60px);
        padding:4px;
      }
      // &.left {
      //   transform: rotate(-30deg) translate(-115px, -25px);
      //   @media (max-width:800px) {
      //     transform: rotate(-30deg) translate(-140px, -60px);
      //   }
      // }
    }
  }
  
  .bg-clients {
    background-image: url(/static/clients-bg.jpg);
    background-size:contain;
  }
  .bg-orange {
    background-image: url(/static/orange-bg.png);
    background-position:top center;
    background-size:cover;
  }
  .bg-darkblue {
    background-image: url(/static/darkblue-bg2.png);
    background-size:contain;
  }
  .bg-lightblue {
    background-image: url(/static/lightblue-bg.jpg);
    background-position:top center;
    background-size:cover;
  }
  .bg-map {
    background-image: url(/static/map2.jpg);
    background-position:top center;
    background-size:cover;
  }
  .bmv-reflective {
    min-height: 100vh;
    // padding-bottom:$footerSize;
  }
  .bmv-reflection-container {
    position: fixed;
    bottom: 0px;
    height: $footerSize;
    width: 100%;
    overflow: hidden;
    background-color: #000;
    // border-top:1px solid #000;
    z-index: 10000;
    // &.top {
    //   top: 0px;
    //   bottom: auto;
    //   border-top: none;
    //   background-color: transparent;
    //   background-color: black;
    //   // border-bottom:1px solid #ccc;
    // }
  }
  .bmv-reflection {

    filter: blur($blur);
    opacity: $opacity;
    transform: translateZ(0) scale(1, -1);
  }
</style>
<script>
  import bubbles from './components/Bubbles'
  import bmvBarChart from './components/Chart'
  import clientlist from './components/Client'
  import about from './components/About'
  import contact from './components/Contact'
  import gallery from './components/Gallery'
  
  export default {
    name: 'app',
    components: {
      bmvBarChart,
      bubbles,
      clientlist,
      about,
      gallery,
      contact
    },
    data: function() {
      return {
        start: 0,
        change: 0,
        increment: 20,
        elapsedTime: 0,
        scrollElement: document.body,
        duration: 750,
        segments: [{
            'el': '.home',
            'link': '.homelink'
          },
          {
            'el': '.about',
            'link': '.aboutlink'
          },
          {
            'el': '.clients',
            'link': '.clientslink'
          },
          {
            'el': '.results',
            'link': '.resultslink'
          },
          {
            'el': '.gallery',
            'link': '.gallerylink'
          },
          {
            'el': '.contact',
            'link': '.contactlink'
          }
        ]
      }
    },
    methods: {
      requestTick() {
        // if (!this.ticking) {
          requestAnimationFrame(this.scrollEvents)
          // this.ticking = true
        // }
      },
      scrollEvents() {
        // this.ticking = false
        let spot = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        for (var seg of this.segments) {
          if (spot > seg.start && spot < seg.end) {
            var link = document.querySelector(seg.link)
            link.classList.add('active')
          } else {
            document.querySelector(seg.link).classList.remove('active')
          }
        }
      },
      setupSegments() {
        setTimeout( () => {
        for (var seg of this.segments) {
          const rect = document.querySelector(seg.el).getBoundingClientRect()
          const top = (rect.top + window.pageYOffset) - (Math.max(document.documentElement.clientHeight, window.innerHeight || 0) / 3)
          seg.start = Math.max(top, -1)
          seg.end = top + rect.height
        }
        },60)
      }
    },
    mounted() {
      this.requestTick()
      window.addEventListener('load',this.setupSegments)
      window.addEventListener('scroll', this.requestTick)
      window.addEventListener('resize', this.requestTick)
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?4324a769